<template>

  <div class="container-fluid">
    <!--    <div>-->
    <!--      <p>dasd</p>-->
    <!--      <b-table :items="unit_air_vol_items" :fields="unit_air_vol_fields" thead-class="small border-bottom"-->
    <!--               class='table table-borderless table-striped mb-5'></b-table>-->
    <!--    </div>-->
    <!--    <div>-->
    <!--      <h5 class="my-3">{{ __('lang.kwl.overview.supply_exhaust_data') }}</h5>-->
    <!--      <overviewRoomAirVolumes :index="index" :id="id"></overviewRoomAirVolumes>-->
    <!--    </div>-->

    <div v-if="configuration.norms_id==1">
      <b-table v-if="unit.ventilationMeasure != 1 && unit.ventilationMeasure != 7" :fields="unit_air_vol_fields"
               :items="unit_air_vol_items" class='table table-borderless table-striped mb-5'
               thead-class="small border-bottom"></b-table>
      <b-table v-else :fields="unit_air_vol_18017_fields" :items="unit_air_vol_18017_items"
               class="table table-striped mb-5"
               responsive thead-class="d-none"></b-table>
    </div>
    <div v-else>
      <b-table :fields="unit_air_vol_fields_at" :items="unit_air_vol_items_at"
               class='table table-borderless table-striped mb-5'
               thead-class="small border-bottom">

        <template #cell(bdvm)="row">
          <ModalComponentAt :modalVariation="row.item.bdvm"></ModalComponentAt>
        </template>
      </b-table>
    </div>

    <div>
      <h5 class="my-3">{{ __('lang.kwl.overview.supply_exhaust_data') }}</h5>
      <overviewRoomAirVolumes :id="id" :index="index"></overviewRoomAirVolumes>
    </div>


  </div>
</template>

<script>
import log from '@services/logger/index'
import overviewRoomAirVolumes from './RoomAirVolumesComponent'
import Unit from '@models/building/Unit'
import {setLabels} from '@services/helpers/langHandler'
import Configuration from "@models/project/Configuration";
import ModalComponentAt from '../AirvolumeAndDetails/Partials/at/ModalComponent.vue';


export default {
  props: [
    'index',
    'id'
  ],
  components: {
    overviewRoomAirVolumes,
    ModalComponentAt

  },
  data() {
    return {}
  },
  methods: {
    setLabels: setLabels,
  },
  computed: {
    unit() {
      return Unit.query().where('id', this.id).with('airvolume').first();
    },
    unit_air_vol_items: function () {
      return [
        {
          airtype: this.__('lang.kwl.airvolume_calc.airflow_volume_fan'),
          fl: parseInt(this.unit.airvolume.fl),
          rl: parseInt(this.unit.airvolume.rl),
          nl: parseInt(this.unit.airvolume.nl),
          il: parseInt(this.unit.airvolume.il)
        },
        {
          airtype: this.__('lang.kwl.airvolume_calc.air_change_rate'),
          fl: parseFloat(this.unit.airvolume.flExchange).toFixed(2),
          rl: parseFloat(this.unit.airvolume.rlExchange).toFixed(2),
          nl: parseFloat(this.unit.airvolume.nlExchange).toFixed(2),
          il: parseFloat(this.unit.airvolume.ilExchange).toFixed(2)
        }
      ]
    },

    unit_air_vol_items_at: function () {
      return [
        {
          airtype: this.__('lang.kwl.airvolume_calc.airflow_volume_fan'),
          totalSupplyAir: this.unit.airvolume.totalSupplyAir,
          bdonp: this.unit.peopleNumber,
          bdsvp: this.unit.airvolume.totalSupplyAir / parseInt(this.unit.peopleNumber),
          bdvm: (this.unit.airvolume.totalSupplyAir / this.unit.peopleNumber <= 30) ? 1 : ((this.unit.airvolume.totalSupplyAir / this.unit.peopleNumber > 30 && this.unit.airvolume.totalSupplyAir / this.unit.peopleNumber <= 40) ? 2 : 3)

        },
      ]
    },

    unit_air_vol_fields: {
      get() {
        return this.setLabels(this.$store.state.inputs.unit_air_vol_fields);
      },
    },

    unit_air_vol_fields_at: {
      get() {
        return this.setLabels(this.$store.state.inputs.unit_air_vol_fields_at)
      },
    },
    unit_air_vol_18017_fields: {
      get() {
        return this.setLabels(this.$store.state.inputs.unit_air_vol_18017_fields)
      },
    },
    unit_air_vol_18017_items: function () {
      if (!this.unit.airvolume) return []
      return [
        {
          text: this.__('lang.kwl.airvolume_calc.18017_fs'),
          volume: Math.round(this.unit.airvolume.fl) + ' ' + this.__('lang.units.airflow_volume'),
        },
        {
          text: this.__('lang.kwl.airvolume_calc.18017_max_ventialtion'),
          volume: Math.round(this.unit.airvolume.totalNeedAir) + ' ' + this.__('lang.units.airflow_volume'),
        },
        {
          text: this.__('lang.kwl.airvolume_calc.18017_ald'),
          volume: Math.round(this.unit.airvolume.ald) + ' ' + this.__('lang.units.airflow_volume'),
        },
        {
          text: this.__('lang.kwl.airvolume_calc.18017_infiltration'),
          volume: Math.round(this.unit.airvolume.infiltrationAir) + ' ' + this.__('lang.units.airflow_volume'),
        },
      ]
    },

    configuration() {
      return Configuration.query().with(['project']).first()
    },
  }
}
</script>
